import styled from "styled-components";
import HeaderTextWithIcon from "./PlayerDetail/HeaderTextWithIcon";
import { ITeams } from "../types/IPlayerDetail";
import { useState } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { BothPlayerImageContainer, FullViewBtn, PartnershipScoreContainer, PlayerImageContainer } from "./PlayerInfo";
import Pitch from "./Pitch";
import VisibleON from "../assets/icons/VisibleON.png";
import { FullModuleFitView } from "../pages/Chemistry/UIContent";
import ModuleFitLargePitch from "./ModuleFitLargePitch";

const StyledTags = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  width: 100%;
  .icon {
    color: ${({ theme }) => theme.NumberColor};
  }
`;

interface ModulePitchProp {
  clubData: ITeams;
  playerData?: { playerId: number; playerClubURL: string };
}

export const ModulePitch: React.FC<ModulePitchProp> = ({ clubData, playerData }) => {
  const [isHover, setIsHover] = useState<boolean>(false);
  const [isFullViewOpen, setIsFullViewOpen] = useState<boolean>(false);
  const [currentPlayerView, setCurrentPlayerView] = useState<number>(playerData?.playerId!);
  const { theme } = useTheme();
  const oldChemistry = {
    positionResults: clubData?.playerChemistryWithSystemFit?.oldPlayerChemistry.positionResults,
    teamChemstriys: clubData?.playerChemistryWithSystemFit?.oldPlayerChemistry.teamChemstriys,
    systemfitScore: clubData?.playerChemistryWithSystemFit?.oldSystemFit,
  };
  const newChemistry = {
    positionResults: clubData?.playerChemistryWithSystemFit?.newPlayerChemistry.positionResults,
    teamChemstriys: clubData?.playerChemistryWithSystemFit?.newPlayerChemistry.teamChemstriys,
    systemfitScore: clubData?.playerChemistryWithSystemFit?.newSystemFit,
  };
  const newSystemFit = newChemistry?.systemfitScore;
  const oldSystemFit = oldChemistry?.systemfitScore;
  const newPlayer = newChemistry?.positionResults?.find((player) => player.playerId === playerData?.playerId);
  const oldPlayer = oldChemistry?.positionResults?.find((player) => player.playerId === clubData?.selectedPlayerId);
  const filteredNewChemistry = newChemistry?.teamChemstriys?.filter(
    (connection) => newPlayer?.playerId! === connection.player1 || newPlayer?.playerId! === connection.player2
  );
  const filteredOldChemistry = oldChemistry?.teamChemstriys?.filter(
    (connection) => oldPlayer?.playerId === connection.player1 || oldPlayer?.playerId === connection.player2
  );

  return (
    <>
      <br />
      <div className="stat-table-column">
        <StyledTags>
          <div
            className="player-tags-wrapper"
            style={{ display: "flex", flexDirection: "row", position: "relative", justifyContent: "space-between" }}
          >
            <div className="system-fit-header">
              <HeaderTextWithIcon text={"Predicted system fit"} isIcon={false} />
              {newSystemFit > 0 && (
                <PartnershipScoreContainer>
                  <p>AVERAGE KEY</p>
                  <p>
                    PARTNERSHIP SCORE
                    <span style={{ marginLeft: "15px" }}>
                      {newSystemFit}
                      <span style={{ color: newSystemFit - oldSystemFit > 0 ? "#00D1A8" : "#FF3864" }}>
                        {newSystemFit - oldSystemFit > 0 && "+"}
                        {newSystemFit - oldSystemFit}
                      </span>{" "}
                    </span>
                  </p>
                </PartnershipScoreContainer>
              )}
            </div>
            <div style={{ position: "relative" }} onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
              <Pitch
                isPattern={false}
                positionResults={newChemistry.positionResults}
                teamChemistry={filteredNewChemistry}
                currentView={"moduleChemistry"}
                modulefitPlayer={playerData?.playerId!}
              />
              {isHover && (
                <FullViewBtn onClick={() => setIsFullViewOpen(true)}>
                  <img src={VisibleON} alt="full-view-button" />
                </FullViewBtn>
              )}
            </div>
          </div>
        </StyledTags>
        <FullModuleFitView
          header={"System fit comparison"}
          theme={theme}
          isFullViewOpen={isFullViewOpen}
          setIsFullViewOpen={setIsFullViewOpen}
        >
          <BothPlayerImageContainer>
            <div className="image-container">
              <PlayerImageContainer isSelected={currentPlayerView === playerData?.playerId}>
                <img src={newPlayer?.playerImageURL!} alt="" onClick={() => setCurrentPlayerView(playerData?.playerId!)} />
              </PlayerImageContainer>
              <PlayerImageContainer isSelected={currentPlayerView === oldPlayer?.playerId}>
                <img src={oldPlayer?.playerImageURL} alt="" onClick={() => setCurrentPlayerView(oldPlayer?.playerId!)} />
              </PlayerImageContainer>
            </div>
            <ModuleFitLargePitch
              positionResults={currentPlayerView === oldPlayer?.playerId ? oldChemistry.positionResults : newChemistry.positionResults}
              teamChemistry={currentPlayerView === oldPlayer?.playerId ? filteredOldChemistry : filteredNewChemistry}
              newPlayerID={newPlayer?.playerId}
              newPlayerClubURL={playerData?.playerClubURL}
              oldPlayerID={oldPlayer?.playerId}
              isShowClubImg={true}
            />
          </BothPlayerImageContainer>
        </FullModuleFitView>
      </div>
    </>
  );
};
